// Keeps the filter dropdown panels (.facets__display) visible and correctly
// positioned even though their scrollable row (.facets__wrapper) uses
// overflow-x: auto. An overflow-x: auto container also clips overflowing
// absolutely-positioned descendants on the Y axis, which was hiding the
// dropdown panels. Fix: switch the open panel to position: fixed (which
// escapes ancestor overflow clipping) and position it under its button
// with JS, keeping it in sync on resize/scroll.
(function () {
  if (window.__facetsDisplayPositionInit) return;
  window.__facetsDisplayPositionInit = true;

  function getPanel(details) {
    return details.querySelector(':scope > .facets__display');
  }

  function positionPanel(details) {
    var summary = details.querySelector(':scope > summary');
    var panel = getPanel(details);
    if (!summary || !panel) return;
    var rect = summary.getBoundingClientRect();
    panel.style.position = 'fixed';
    panel.style.top = rect.bottom + 8 + 'px';
    panel.style.left = rect.left + 'px';
    panel.style.right = 'auto';
  }

  function resetPanel(details) {
    var panel = getPanel(details);
    if (!panel) return;
    panel.style.position = '';
    panel.style.top = '';
    panel.style.left = '';
    panel.style.right = '';
  }

  function refreshOpenPanels() {
    document.querySelectorAll('.facets__disclosure[open]').forEach(positionPanel);
  }

  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || !details.classList || !details.classList.contains('facets__disclosure')) return;
      if (details.open) {
        positionPanel(details);
      } else {
        resetPanel(details);
      }
    },
    true
  );

  window.addEventListener('resize', refreshOpenPanels);
  window.addEventListener('scroll', refreshOpenPanels, true);
})();
